/**
 * Utility class for random
 */
export class RNG {
    /**
     * Gets a random item from an array
     * @param array the array to get an item from
     * @returns the random item; null if the array is empty
     */
    static getItem<T>(array: T[]): T | null {
        if (!array.length) {
            return null;
        }
        return array[Math.floor(Math.random() * array.length)];
    }

    /**
     * Returns a uniform distributed random value between lowerBound and upperBound
     * @param {number} lowerBound The lower end of the range to return a value from
     * @param {number} upperBound The upper end of the range to return a value from
     * @returns random value between lowerBound and upperBound
     */
    static getUniform(lowerBound: number, upperBound: number) {
        return Math.random() * (upperBound - lowerBound) + lowerBound;
    }

    /**
     * Returns a random integer rounded value between lowerBound and upperBound
     * @param {number} lowerBound The lower end of the range to return a value from, inclusive
     * @param {number} upperBound The upper end of the range to return a value from, inclusive
     * @returns random value between lowerBound and upperBound
     */
    static getUniformInt(lowerBound: number, upperBound: number) {
        let max = Math.max(lowerBound, upperBound);
        let min = Math.min(lowerBound, upperBound);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
